import { Text } from '@thefarmersfront/kitchen';

import { CircleProgress } from '~/components/common/chart/CircleProgress';

import { formatNumber } from '~/utils/common';

import styles from './SummaryStatus.module.scss';

interface SummaryStatusProps {
  total: number;
  current: number;
  color: string;
}

const SummaryStatus = ({ total, current, color }: SummaryStatusProps) => {
  const percent = total > 0 ? Math.round((current / total) * 100 * 10) / 10 : 0;

  return (
    <div className={styles.container}>
      <CircleProgress
        percent={percent}
        value={`${percent}%`}
        suffix={null}
        trackColor="#E8E8E8"
        progressColor={color}
        labelFontStyle={{ fontSize: 24, fontWeight: 700 }}
        suffixFontStyle={{ fontSize: 24, fontWeight: 700, dx: 0, dy: 0 }}
      />
      <div className={styles.status}>
        <Text size="large" weight="regular">
          {formatNumber(current)}
        </Text>
        <div className={styles['status-divider']} />
        <Text size="large" weight="regular">
          {formatNumber(total)}
        </Text>
      </div>
    </div>
  );
};

export { SummaryStatus };
